import {
  EOfferFormatKey,
  IQuantityFormat,
  ITimeFormat
} from '../../StoreSettings.types';

import {
  QuantityFieldPath,
  TimeFieldPath
} from './AbbreviationsSettingsV2.types';

export const getQuantityFieldPath = (
  sectionKey: EOfferFormatKey,
  fieldKey: keyof IQuantityFormat
): QuantityFieldPath => `numberFormat.${sectionKey}.quantity.${fieldKey}`;

export const getTimeFieldPath = (
  sectionKey: EOfferFormatKey,
  fieldKey: keyof ITimeFormat
): TimeFieldPath => `numberFormat.${sectionKey}.time.${fieldKey}`;
